<template>
  <div class="ChangePassword" style="padding-top: 1rem">
    <navTitle
            :title="$router.app._route.query.ti ? $router.app._route.query.ti : 'ChangePassword'"
            path="/user/data"
    ></navTitle>
    <!--<div class="phone">-->
      <!--Current phone number:<input type="text" v-model="phone" disabled />-->
    <!--</div>-->
    <div class="list">
      <div class="item">
        <input type="password" placeholder="Enter your current password" v-model="last_password" />
      </div>
      <div class="item">
        <input type="password" placeholder="Set your new password" v-model="new_password" />
      </div>
      <div class="item">
        <input type="password" placeholder="Confirm new password" v-model="new_password2" />
      </div>

    </div>
    <div class="confirmBnt bg-color-red" @click="confirm">Confirm change</div>
  </div>
</template>
<style scoped>
.ChangePassword .phone input {
  width: 2rem;
  text-align: center;
}
</style>
<script>
// import { mapGetters } from "vuex";
import navTitle from "@components/navTitle";

import { registerResetOld, getUserInfo } from "@api/user";

export default {
  name: "ChangePassword",
  components: {navTitle},
  props: {},
  data: function() {
    return {
      last_password: "",
      new_password: "",
      new_password2:'',
      captcha: "",
      phone: "", //隐藏几位数的手机号；
      yphone: "" //手机号；
    };
  },
  // computed: mapGetters(["userInfo"]),
  mounted: function() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo: function() {
      let that = this;
      getUserInfo().then(res => {
        that.yphone = res.data.phone;
        let reg = /^(\d{3})\d*(\d{4})$/;
        that.phone = that.yphone.replace(reg, "$1****$2");
      });
    },
    async confirm() {
      let that = this;
      const { last_password,new_password, new_password2 } = that;
      if(!last_password){
        return  that.$dialog.error("Please enter you current password");
      }
      if(!new_password){
        return  that.$dialog.error("Please enter you new password");
      }
      if(!new_password2){
        return  that.$dialog.error("Please enter you new password again");
      }
      if (new_password !== new_password) return that.$dialog.error("Password does not match");
      registerResetOld({
        oldpwd: that.last_password,
        password: that.new_password
      })
        .then(res => {
          that.$dialog.success(res.msg).then(() => {
            that.$router.go(-1)
            // that.$router.replace({ name: "Login" });
          });
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    async code() {
      let that = this;
      const { yphone } = that;
      try {
        await that
          .$validator({
            yphone: [
              required(required.message("phone")),
              chs_phone(chs_phone.message())
            ]
          })
          .validate({ yphone });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      registerVerify({ phone: yphone })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    }
  }
};
</script>
